var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSelectBox(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: "1.5px",
    transform: "scale(0.8)",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 4,
    height: 4,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 2,
    width: 4,
    height: 4,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 18,
    width: 4,
    height: 4,
    rx: 1
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4,
    y1: 9,
    x2: 4,
    y2: 15
  }), /*#__PURE__*/React.createElement("line", {
    x1: 20,
    y1: 9,
    x2: 20,
    y2: 11
  }), /*#__PURE__*/React.createElement("line", {
    x1: 15,
    y1: 4,
    x2: 9,
    y2: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 11,
    y1: 20,
    x2: 9,
    y2: 20
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.33,22h-.09a.35.35,0,0,1-.24-.32v-10a.34.34,0,0,1,.33-.34.32.32,0,0,1,.21.08l7.34,6a.33.33,0,0,1-.21.59H17.18l-2.57,3.85A.35.35,0,0,1,14.33,22Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectBox);
export default __webpack_public_path__ + "static/media/select_box.608cfb9bdbe2f4fc38270adb7ae06404.svg";
export { ForwardRef as ReactComponent };